// @flow
import * as React from 'react'
import css from './index.css'
import noop from 'lodash/noop'
import {resolveCss} from '$util'
import frankSpinner from '$assets/icons/frankSpinner.svg'

type Props = {
  style: 'outline' | 'bold' | 'subtle',
  hasTopMargin?: boolean,
  surroundMargin?: boolean,
  loading?: boolean,
  disabled?: boolean,
  children?: React.Node,
  icon?: React.Node,
  css?: any,
  onClick?: Function,
  isExpanding?: boolean,
  isFullWidth?: boolean,
  externalLink?: boolean,
  'data-tid'?: string,
}

const GenericButton = ({
  style,
  externalLink,
  children,
  css: customCss,
  disabled,
  loading,
  hasTopMargin,
  onClick,
  surroundMargin,
  isExpanding,
  isFullWidth,
  ...rest
}: Props) => {
  const classes = resolveCss(css, customCss)

  return (
    <button
      disabled={disabled}
      {...classes(
        'container',
        style,
        !!hasTopMargin && 'hasTopMargin',
        disabled && 'disabled',
        surroundMargin && 'surroundMargin',
        isExpanding && 'expand',
        isFullWidth && 'full',
        externalLink && 'externalLink'
      )}
      onClick={disabled || loading ? noop : onClick}
      {...rest}
    >
      {children}
      {loading && (
        <div {...classes('spinnerContainer')}>
          <img {...classes('icon')} src={frankSpinner} alt="loading" />
        </div>
      )}
    </button>
  )
}

export default GenericButton



// WEBPACK FOOTER //
// ./src/common/components/GenericButton/index.js